import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Space, Drawer, Modal, Select, Input } from "antd";
import { CheckCircleOutlined, WarningOutlined } from "@ant-design/icons";
import right_arrow_icon from "./../../../assets/images/right-arrow.png";
import Modals from "react-modal";
import styled from "styled-components";
// Thunk
import {
  sync_meta_templates_thunk,
  get_all_templates_thunk,
  get_template_buttons_list_thunk,
  get_root_template_thunk,
  set_root_template_thunk,
  get_mediaurl_by_templateid_thunk,
  set_mediaurl_by_templateid_thunk,
  create_thread_thunk,
} from "./../threads-thunk";

const ListAllTemplates = () => {
  const tableStyles = `
    .styled-table {
      width: 100%;
      border-collapse: collapse;
      margin: 25px 0;
      font-size: 15px;
      text-align: left;
      border: 2px solid #ddd;
    }

    .styled-table th, .styled-table td {
      padding: 12px 15px;
      border-bottom: 1px solid #ddd;
      border-right: 1px solid #ddd;
    }

    .styled-table th {
      background-color: #f2f2f2;
    }

    .styled-table tbody tr:hover {
      background-color: #f5f5f5;
    }
  `;
  const PrimaryButton = styled.button`
    background-color: #3498db;
    color: #fff;
    padding: 10px 20px;
    border: none;
    cursor: pointer;
  `;

  const CustomModal = styled(Modals)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 150px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    width: 30%;
  `;

  const CustomOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const ModalContent = styled.div`
    text-align: center;
    color: white;
  `;

  const OkButton = styled.button`
    background-color: #27ae60;
    color: #fff;
    padding: 10px 20px;
    margin: 0 10px;
    border: none;
    cursor: pointer;
  `;
  const CancelButton = styled.button`
    background-color: #e74c3c;
    color: #fff;
    padding: 10px 20px;
    border: none;
    cursor: pointer;
  `;

  const dispatch = useDispatch();

  useEffect(() => {
    get_template_list();
    get_root_template();
  }, []);

  const loading = useSelector((state) => state.threadsslice.loading);
  const templatesdata = useSelector((state) => state.threadsslice.data);
  const syncdata = useSelector((state) => state.threadsslice.sync_data);
  const templatebuttons_data = useSelector(
    (state) => state.threadsslice.templatebuttons_data
  );
  const roottemplate_getdata = useSelector(
    (state) => state.threadsslice.roottemplate_getdata
  );
  const mediaurl_getdata = useSelector(
    (state) => state.threadsslice.mediaurl_getdata
  );

  // ---------------- Data functions -------------------------
  const sync_meta_templates = async () => {
    await dispatch(sync_meta_templates_thunk());
    get_root_template();
    get_template_list();
  };
  const get_root_template = async () => {
    await dispatch(get_root_template_thunk());
  };
  const set_root_template = async () => {
    setOpenTemplateViewDrawer(false);
    await dispatch(set_root_template_thunk(selectedTemplate.templateId));
    get_root_template();
  };
  const get_mediaurl_bytemplateid = async (templateId) => {
    await dispatch(get_mediaurl_by_templateid_thunk(templateId));
  };
  const set_mediaurl_bytemplateid = async () => {
    const templateId = selectedTemplate.templateId,
      mediaUrl = mediaUrlInput;
    await dispatch(set_mediaurl_by_templateid_thunk({ templateId, mediaUrl }));
    get_mediaurl_bytemplateid(selectedTemplate.templateId);
  };
  const get_template_list = async () => {
    await dispatch(get_all_templates_thunk());
  };
  // ---------------------------------------------------------

  // ------------------------- Drawer ------------------------
  const [openTemplateViewDrawer, setOpenTemplateViewDrawer] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const viewtemplate_on_click = async (template) => {
    setOpenTemplateViewDrawer(true);
    setSelectedTemplate(template);
    await dispatch(get_template_buttons_list_thunk(template.templateId));
    get_mediaurl_bytemplateid(template.templateId);
  };
  const closeTemplateViewDrawer = () => {
    setSelectedTemplate(null);
    setOpenTemplateViewDrawer(false);
  };
  // ---------------------------------------------------------

  //---------------------- Set target template ---------------
  const [showTargetTemplateModal, setShowTargetTemplateModal] = useState(false);
  const [fromTemplateButtonData, setFromTemplateButtonData] = useState(null);
  const [toTemplate, setToTemplate] = useState(null);

  const open_target_template_modal = (buttondata) => {
    setFromTemplateButtonData(buttondata);
    setShowTargetTemplateModal(true);
  };
  const close_target_template_modal = () => {
    setFromTemplateButtonData(null);
    setToTemplate(null);
    setShowTargetTemplateModal(false);
  };
  const target_template_select_on_change = (value) => {
    const templateobj = templatesdata?.find(
      (item) => item.templateId === value
    );
    setToTemplate(templateobj);
  };
  const target_template_modal_ok_button_click = async () => {
    const fromTemplateId = fromTemplateButtonData.templateId;
    const fromTemplateName = fromTemplateButtonData.templateName;
    const fromTemplateButton = fromTemplateButtonData.templateButton;
    const toTemplateId = toTemplate.templateId;
    const toTemplateName = toTemplate.templateName;

    const body = {
      fromTemplateId,
      fromTemplateName,
      fromTemplateButton,
      toTemplateId,
      toTemplateName,
    };
    await dispatch(create_thread_thunk(body));
    dispatch(get_template_buttons_list_thunk(fromTemplateId));
    close_target_template_modal();
  };
  // ---------------------------------------------------------

  // -------------------- Set Media Url ----------------------
  const [mediaUrlInput, setMediaUrlInput] = useState(null);
  const [showMediaUrlModal, setShowMediaUrlModal] = useState(false);

  const open_media_url_modal = () => {
    setShowMediaUrlModal(true);
  };
  const close_media_url_modal = () => {
    setShowMediaUrlModal(null);
    setShowMediaUrlModal(false);
  };
  const media_url_modal_ok_button_click = () => {
    set_mediaurl_bytemplateid();
    close_media_url_modal();
  };
  // ---------------------------------------------------------
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleOkClick = () => {
    // Call your function here
    sync_meta_templates();

    // Close the modal after clicking "OK"
    closeModal();
  };

  return (
    <>
      <div>
        Since our all templates are being created in META's template panel, all
        the details about current templates to be synced to our database.
        <br /> To achieve this click on "Sync META Templates" button. <br />
        {loading && <div>Loading data ...</div>}
        {!loading && (
          <>
            <Button type="primary" onClick={openModal}>
              Sync META Templates
            </Button>
            <CustomModal
              isOpen={isModalOpen}
              onRequestClose={closeModal}
              contentLabel="Confirmation Modal"
              ariaHideApp={false}
            >
              <CustomOverlay>
                <ModalContent>
                  <h2>Confirm Action</h2>
                  <p>Are you sure you want to sync META Templates?</p>
                  <OkButton onClick={handleOkClick}>OK</OkButton>
                  <CancelButton onClick={closeModal}>Cancel</CancelButton>
                </ModalContent>
              </CustomOverlay>
            </CustomModal>
          </>
        )}
      </div>
      <br />
      <br />

      <div>
        There should be an root template to initialise a conversation.
        {roottemplate_getdata && roottemplate_getdata.length > 0 && (
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              padding: "10px",
              border: "1px solid black",
              backgroundColor: "rgb(25,118,210)",
              display: "flex",
            }}
          >
            <span
              style={{
                marginRight: "10px",
                color: "white",
                fontSize: "18px",
              }}
            >
              <CheckCircleOutlined />
            </span>
            <span
              style={{
                color: "white",
              }}
            >
              Current root template is: {roottemplate_getdata[0].templateName}
            </span>
          </div>
        )}
        {(!roottemplate_getdata || roottemplate_getdata.length <= 0) && (
          <div
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              padding: "10px",
              border: "1px solid red",
              backgroundColor: "#ff000036",
            }}
          >
            <span
              style={{
                marginRight: "10px",
                color: "darkred",
                fontSize: "18px",
              }}
            >
              <WarningOutlined />
            </span>
            There is NO root template found{" "}
          </div>
        )}
        To setroot template click on a template listed below and click on "Set
        as Root" button. <br />
      </div>
      <br />
      <div>
        Here is the list templates, you have created inside META platform.{" "}
        <br />
        <br />
        <span style={{ fontWeight: "bold" }}>
          There are {templatesdata?.length} template(s) found.
        </span>
      </div>
      {loading && <div>Loading data ...</div>}
      {!loading && (
        <div>
          {templatesdata?.map((template, i) => (
            <div
              key={i}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                padding: "10px",
                margin: "10px",
                border: "1px solid #c2c2c2",
                cursor: "pointer",
              }}
              onClick={() => viewtemplate_on_click(template)}
            >
              <style>{tableStyles}</style>
              <table className="styled-table">
                <thead>
                  <tr>
                    <th>NO</th>
                    <th>TemplateName</th>
                    <th>Language</th>
                    <th>Status</th>
                    <th>Category</th>
                    <th>Media Type</th>

                    <th>Root</th>
                    <th>Replay Button</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{i + 1}</td>
                    <td> {template.templateName}</td>
                    <td>{template.templateLang}</td>
                    <td>{template.templateStatus}</td>
                    <td>{template.templateCategory}</td>

                    <td>{template.mediaType ?? "No Media"}</td>
                    <td>{"" + template.isRoot}</td>
                    <td>{template.templateButtons.length}</td>
                  </tr>
                </tbody>
              </table>
              {/* <div style={{ width: "30px" }}>{i + 1}</div>
              <div style={{ width: "180px" }}>{template.templateId}</div>
              <div style={{ width: "250px", display: "block" }}>
                <span></span>
                {template.templateName}
              </div>
              <div style={{ width: "60px" }}>{template.templateLang}</div>
              <div style={{ width: "100px" }}>{template.templateStatus}</div>
              <div style={{ width: "100px" }}>{template.templateCategory}</div>
              <div style={{ width: "70px" }}>{template.mediaType}</div>
              <div style={{ width: "50px" }}>{"" + template.isRoot}</div>
              <div style={{ width: "30px" }}>
                {template.templateButtons.length}
              </div> */}
              {/* <div style={{ width: "300px" }}>{template.mediaUrl}</div> */}
            </div>
          ))}
        </div>
      )}

      {/* Drawer */}
      <Drawer
        title={selectedTemplate ? selectedTemplate.templateName : ""}
        size="large"
        placement="right"
        open={openTemplateViewDrawer}
        onClose={closeTemplateViewDrawer}
        footer={
          <Space
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
            }}
          >
            {/* <Button onClick={closeTemplateViewDrawer}>OK</Button> */}
            <Button type="primary" onClick={set_root_template}>
              Set as root template
            </Button>
          </Space>
        }
      >
        {loading && <div>Loading data ...</div>}
        {!loading && (
          <div>
            {/* ---------------- template media url input ---------------- */}
            {selectedTemplate?.mediaType && (
              <div>
                <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                  Set {selectedTemplate?.mediaType} media url
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ width: "100%", padding: "10px" }}>
                    <div>
                      <Button type="primary" onClick={open_media_url_modal}>
                        Set Media
                      </Button>
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid gray",
                      backgroundColor: "#fbfbfb",
                      wordBreak: "break-all",
                    }}
                  >
                    {mediaurl_getdata?.mediaUrl
                      ? mediaurl_getdata?.mediaUrl
                      : "Media url not set"}
                  </div>
                </div>
              </div>
            )}

            {/* ---------------- template buttons and set their targets ---------------- */}
            <div>
              <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                Set target template for {templatebuttons_data?.length} button(s)
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                }}
              >
                {templatebuttons_data?.map((buttondata, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      margin: "15px",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <Button
                        onClick={() => open_target_template_modal(buttondata)}
                      >
                        {buttondata.templateButton}
                      </Button>
                    </div>
                    <div style={{ width: "100%" }}>
                      <img src={right_arrow_icon} style={{ width: "20%" }} />
                    </div>
                    <div style={{ width: "100%" }}>
                      {buttondata.toTemplateName}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </Drawer>

      {/* Set media url modal */}
      <Modal
        title="Set media url"
        open={showMediaUrlModal}
        onOk={media_url_modal_ok_button_click}
        onCancel={close_media_url_modal}
        style={{ paddingBottom: "150px", height: "300px" }}
        okButtonProps={{ style: { marginTop: "-3%" } }}
        cancelButtonProps={{
          style: { marginTop: "-3%", border: "2px solid black" },
        }}
      >
        <div>
          Enter the url where the media (image/ video) is publicly available.
        </div>
        <div>
          <div style={{ fontSize: "18px", fontWeight: "bold" }}>
            Set {selectedTemplate?.mediaType} media url
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "100%", padding: "10px" }}>
              <Input
                placeholder="Enter media url"
                value={mediaUrlInput}
                onChange={(e) => setMediaUrlInput(e.target.value)}
              />
            </div>
          </div>
        </div>
      </Modal>

      {/* Set target template modal */}
      <Modal
        title="Select target template"
        open={showTargetTemplateModal}
        onOk={target_template_modal_ok_button_click}
        onCancel={close_target_template_modal}
      >
        <div>
          Select template which will be sent to user, on clicking this button.
        </div>
        <div>
          <Select
            placeholder="Select a Template"
            value={toTemplate?.templateId}
            onChange={target_template_select_on_change}
            allowClear
            style={{ width: "100%" }}
          >
            {templatesdata.map((template) => (
              <Select.Option
                key={template.templateId}
                value={template.templateId}
              >
                {template.templateName}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </>
  );
};

export default ListAllTemplates;
